import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from '@mui/material';

import {
    getYearSpreadRoundChart,
    groupByCityAndYears,
    getSumOfAllPerLocationForSelectedYears,
    getYears
} from '../utilities/dataTransformer';

class PopChart extends Component {
    constructor(props) {
        super(props);

        var years = this.makeYearList(2010, 2020);

        var cityAndYears = groupByCityAndYears(years);

        var SumOfAllPerLocationForSelectedYears = getSumOfAllPerLocationForSelectedYears(cityAndYears);

        this.state = {
            selectableYears: getYears(),
            selectedStartYear: "2010",
            selectedEndYear: "2020",
            selectedYears: years,
            shouldUpdate: false,
            gradeIndex: 3,
            options: getYearSpreadRoundChart(years),
            series: SumOfAllPerLocationForSelectedYears,
        }
    }
    makeYearList = (startYear, endYear) => {
        var yearArray = [];

        var startYearInt = parseInt(startYear);
        var endYearInt = parseInt(endYear);

        for (var i = startYearInt; i <= endYearInt; i++) {
            yearArray.push(i);
        }
        return yearArray;
    }

    selectedStartYear = (e) => {
        this.setState({
            ...this.state,
            selectedStartYear: e.target.value,
            shouldUpdate: true
        });
    };

    selectedEndYear = (e) => {
        this.setState({
            ...this.state,
            selectedEndYear: e.target.value,
            shouldUpdate: true
        });
    };

    componentDidUpdate(prevState) {
        if (this.state.shouldUpdate) {
            this.setState({
                ...this.state,
                shouldUpdate: false,
            });

            var years = this.makeYearList(this.state.selectedStartYear, this.state.selectedEndYear);

            var cityAndYears = groupByCityAndYears(years);

            var SumOfAllPerLocationForSelectedYears = getSumOfAllPerLocationForSelectedYears(cityAndYears);

            this.setState({
                options: getYearSpreadRoundChart(years),
                series: SumOfAllPerLocationForSelectedYears
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="chart-container">
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type='pie'
                    height="100%"
                    width="100%"
                /></div>
                <Grid container spacing={5}>
                    <Grid item md={4}>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="yearPicker">
                                Start Jahr
                            </InputLabel>
                            <Select
                                label="Start Jahr"
                                name="yearPicker"
                                id="yearPicker"
                                value={this.state.selectedStartYear}
                                onChange={this.selectedStartYear.bind(this)}
                            >
                                {this.state.selectableYears
                                .filter((year) => year <= this.state.selectedEndYear)
                                .map((year) => (
                                    <MenuItem key={year}
                                        value={year}>
                                        {year}
                                    </MenuItem>
                                ),
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={4}>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="yearPicker">
                                End Jahr
                            </InputLabel>
                            <Select
                                label="End Jahr"
                                name="yearPicker"
                                id="yearPicker"
                                value={this.state.selectedEndYear}
                                onChange={this.selectedEndYear.bind(this)}
                            >
                                {this.state.selectableYears
                                .filter((year) => year >= this.state.selectedStartYear)
                                .map((year) => (
                                    <MenuItem key={year}
                                        value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default PopChart;